import React, { useState } from 'react';
import FormContactAgent from '../PropertyDetails/FaqContactForm';
import '../../Styles/css/bootstrap.css';
import '../../Styles/css/styles.css';
import '../../Styles/scss/component/_accordion.scss'
import { CgMail } from "react-icons/cg";
import { IoCall } from "react-icons/io5";
import { LuMessageSquareMore } from "react-icons/lu";


const Accordians = () => {
    const [activeItem, setActiveItem] = useState(null);

    const handleToggle = (itemId) => {
        setActiveItem(activeItem === itemId ? null : itemId);
    };

    return (
        <section className="section-faq pt-5">
            <div className="tf-container">
                <div className="row">
                    <div className="col-xl-8 col-lg-7">
                        <div className="heading-section mb-48">
                            <h2 className="title">Frequently Asked Questions</h2>
                        </div>

                        {/* General Questions Section */}
                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">General Questions</h3>
                            <div className="box-faq" id="general-faq">
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'general-1' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('general-1');
                                        }}
                                        aria-expanded={activeItem === 'general-1'}
                                    >
                                        What is CoOwnSpace.com? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'general-1' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            CoOwnSpace.com is a platform that enables fractional ownership in real estate, allowing individuals to co-own premium properties with others. Our model makes property investment more accessible, affordable, and hassle-free.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'general-2' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('general-2');
                                        }}
                                        aria-expanded={activeItem === 'general-2'}
                                    >
                                        How does fractional ownership work? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'general-2' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            Fractional ownership allows multiple investors to collectively own a property by purchasing shares. Each owner gets proportional rights to rental income, appreciation, and usage benefits based on their share.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'general-3' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('general-3');
                                        }}
                                        aria-expanded={activeItem === 'general-3'}
                                    >
                                        What types of properties are available? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'general-3' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            We offer a range of properties, including residential, commercial, vacation homes, and co-working spaces.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'general-4' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('general-4');
                                        }}
                                        aria-expanded={activeItem === 'general-4'}
                                    >
                                        Who can invest in fractional ownership? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'general-4' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            Anyone looking to diversify their real estate investments can participate. Whether you're an individual investor, an entrepreneur, or part of a group, CoOwnSpace makes property ownership easy and accessible.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'general-5' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('general-5');
                                        }}
                                        aria-expanded={activeItem === 'general-5'}
                                    >
                                        How is CoOwnSpace different from a REIT? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'general-5' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            CoOwnSpace offers <strong className='text-dark'>direct fractional ownership</strong> in specific properties, giving investors control over asset selection, rental income, and resale. Unlike <strong className='text-dark'>REITs</strong>, which are traded like stocks and managed by professionals, CoOwnSpace allows investors to <strong className='text-dark'>own a physical share of real estate</strong>, benefit from appreciation, and have a say in decisions. While REITs offer liquidity and diversification, they are subject to stock market fluctuations. CoOwnSpace provides a <strong className='text-dark'>more transparent and hands-on real estate</strong> investment with lower entry costs and direct tax benefits.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Investment & Ownership Section */}
                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">Investment & Ownership</h3>
                            <div className="box-faq" id="investment-faq">
                                <div className="faq-item">
                                    <span
                                        href="#"
                                        className={`faq-header h6 ${activeItem === 'investment-1' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-1');
                                        }}
                                        aria-expanded={activeItem === 'investment-1'}
                                    >
                                        How do I invest in a property? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-1' ? 'show' : ''}`}
                                    >
                                        <div className="faq-body">
                                            <ul style={{ listStyleType: 'disc', paddingLeft: '20px', }} >
                                                <li className='text-dark list-text'>Browse available properties on our platform.</li>
                                                <li className='text-dark list-text'>Select a property and choose your desired share percentage.</li>
                                                <li className='text-dark list-text' >Complete the investment process with secure payment.</li>
                                                <li className='text-dark list-text'>Enjoy ownership benefits, including potential rental income and property appreciation.</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-2' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-2');
                                        }}
                                        aria-expanded={activeItem === 'investment-2'}
                                    >
                                        What are the benefits of fractional ownership? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-2' ? 'show' : ''}`}
                                    >
                                        <div className='faq-body'>
                                            <ul className='gap-2 px-5 '>
                                                <li className='text-dark list-text px-5'><strong>Lower Investment Cost:</strong> Own premium properties with smaller capital.</li>
                                                <li className='text-dark list-text px-5'><strong>Passive Income:</strong> Earn rental income without managing the property.</li>
                                                <li className='text-dark list-text px-5'><strong>Diversification:</strong> Spread your investments across multiple properties.</li>
                                                <li className='text-dark list-text px-5'><strong>Hassle-Free Management:</strong> CoOwnSpace handles property maintenance and legal formalities.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-3' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-3');
                                        }}
                                        aria-expanded={activeItem === 'investment-3'}
                                    >
                                        How is property ownership legally structured? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-3' ? 'show' : ''}`}
                                    >
                                        <div className='faq-body'>
                                        <p className=' list-text p-1'>Property ownership is legally structured through a Special Purpose Vehicle (SPV) created for each asset to pool investor funds and acquire the property. Depending on the SPV's structure, you become a fractional owner in the following ways:</p>
                                        <ul className='px-5 d-flex flex-column gap-3'>
                                            <li className=' list-text p-1'>SPV as a Private Limited Company: You hold a combination of equity shares and debentures in the company, proportional to your investment.</li>
                                            <li className='list-text p-1'>SPV as a Limited Liability Partnership (LLP): You become a registered partner in the LLP, sharing ownership based on your investment stake.</li>

                                        </ul>
                                        <p className='text-dark list-text p-1'>This structure ensures legal clarity, asset protection, and seamless management of fractional ownership.</p>
                                    </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-4' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-4');
                                        }}
                                        aria-expanded={activeItem === 'investment-4'}
                                    >
                                        What is a Special Purpose Vehicle (SPV)? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-4' ? 'show' : ''}`}
                                    >
                                        <p className='faq-body'>A <strong className='fw-medium text-dark'> Special Purpose Vehicle (SPV) </strong> is a legally distinct entity formed for a specific objective. In the case of<span className='text-dark fw-medium'> CoOwnSpace</span>, an SPV is established for each property acquisition, providing a structured platform for investors to pool their funds and co-own the asset. This ensures transparency, legal protection, and efficient management of the investment.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-5' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-5');
                                        }}
                                        aria-expanded={activeItem === 'investment-5'}
                                    >
                                        Can I sell my ownership share? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-5' ? 'show' : ''}`}
                                    >
                                        <p className='faq-body'>
                                            Yes, CoOwnSpace offers a resale marketplace where you can sell your ownership shares to other investors, providing liquidity and flexibility for your investment.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-6' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-6');
                                        }}
                                        aria-expanded={activeItem === 'investment-6'}
                                    >
                                        What documents are required to invest? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-6' ? 'show' : ''}`}
                                    >
                                        <div className='d-flex flex-column gap-3 faq-body'>
                                            <p >  To begin the investment process, you will need to provide the following documents:</p>
                                            <ol className='px-5 py-2 '>
                                                <li><strong className='text-dark list-text2'>PAN Card</strong></li>
                                                <li><strong className='text-dark list-text2'>Address Proof (Aadhaar, Driver’s License, or Passport)</strong></li>
                                                <li><strong className='text-dark list-text2'>Bank Statement or Canceled Cheque with your name printed</strong></li>
                                            </ol>
                                            <p> For NRIs: Only NRO bank account details are accepted.</p>
                                            <p>These documents are required for identity verification and compliance with regulatory guidelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-7' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-7');
                                        }}
                                        aria-expanded={activeItem === 'investment-7'}
                                    >
                                        Is there a lock-in period on my investment? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-7' ? 'show' : ''}`}
                                    >

                                        <p className='faq-body'>
                                            Yes, there is a <span className='text-dark fw-bold'>lock-in period </span> for your investment, which varies depending on the property. This is designed to optimize returns. However, we are actively working on introducing more flexible options for investors in the future.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-8' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-8');
                                        }}
                                        aria-expanded={activeItem === 'investment-8'}
                                    >
                                        What happens to my investment if CoOwnSpace stops operating?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-8' ? 'show' : ''}`}
                                    >
                                        <div className='d-flex flex-column gap-3 faq-body'>
                                            <p>
                                                If <span className='text-dark fw-bold'>CoOwnSpace</span> ceases operations, your investment remains secure. Each property is owned by a separate <span className='text-dark fw-bold'> Special Purpose Vehicle (SPV)</span>, which operates independently of the platform.
                                                <span className='text-dark fw-bold'> CoOwnSpace </span>serves only as an asset manager, meaning the SPV can continue functioning under a different asset manager if needed.
                                            </p>
                                            <p> Additionally, the founders of <span className='text-dark fw-bold'> CoOwnSpace </span> have personally invested in the SPVs, further aligning their interests with investors and ensuring efforts to maximize returns.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-9' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-9');
                                        }}
                                        aria-expanded={activeItem === 'investment-9'}
                                    >
                                        How do I know that my money was invested towards the property?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-9' ? 'show' : ''}`}
                                    >

                                        <p className='faq-body'>
                                            Once the property is fully funded, we complete all legal formalities to register it under the<span className='text-dark fw-bold'> SPV's name</span>, including paying <span className='text-dark fw-bold'> stamp duty, registration fees, and GST.</span> As proof of your investment, we will provide you with the official
                                            <span className='text-dark fw-bold'> registration documents</span>, ensuring full transparency and accountability.
                                        </p>

                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-10' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-10');
                                        }}
                                        aria-expanded={activeItem === 'investment-10'}
                                    >
                                        What documents will I receive against my investments?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-10' ? 'show' : ''}`}
                                    >
                                        <div className='d-flex flex-column gap-5 faq-body'>
                                            <div className='d-flex flex-column gap-2'>
                                                <p>
                                                    Based on the structure of the SPV, we provide you with the following documents:
                                                    SPV as a Private Limited Company:
                                                </p>
                                                <p> - Investment commitment agreement (ICA)</p>
                                                <p> - Share certificate</p>
                                                <p> - Sale Deed</p>
                                                <p> -  Debenture certificate</p>
                                                <p> - Buyback agreement (if applicable)</p>
                                            </div>
                                            <div className='d-flex flex-column gap-2'>
                                                <p>SPV as a LLP:</p>
                                                <p>- Expression of Interest (EoI)</p>
                                                <p> - Shareholders Agreement</p>
                                                <p> - Sale Deed</p>
                                                <p> - Property Management Agreement (if applicable)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-11' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-11');
                                        }}
                                        aria-expanded={activeItem === 'investment-11'}
                                    >
                                        How and when are the yields distributed?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-11' ? 'show' : ''}`}
                                    >

                                        <ul style={{ listStyleType: 'disc', paddingLeft: '20px', }} className='faq-body'>
                                            <li className='text-dark list-text py-1'><span className='text-dark fw-bold'>Rental Properties:</span>  If the asset generates rental income, returns are distributed <span className='text-dark fw-bold'> quarterly or annually </span> directly to your verified bank account. The exact payout dates will be communicated once the property is fully funded and acquired by the<span className='text-dark fw-bold'>SPV.</span></li>
                                            <li className='text-dark list-text py-1'><span className='text-dark fw-bold'>Land Investments:</span> For land plots, returns are distributed <span className='text-dark fw-bold'> at the end of the investment period</span>, when the plot is sold.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-12' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-12');
                                        }}
                                        aria-expanded={activeItem === 'investment-12'}
                                    >
                                        What happens if the property does not get fully funded?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-12' ? 'show' : ''}`}
                                    >

                                        <p className='faq-body'>
                                            We <span className='text-dark fw-bold'> do not accept  </span> until the property is fully funded or has secured <span className='text-dark fw-bold'>investor commitments</span>. If the required funding is not met, your Investment Commitment Agreement or <span className='text-dark fw-bold'> Expression of Interest (EOI) </span> will be voided, and no payment will be collected. This ensures a risk-free commitment process for investors.                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-13' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-13');
                                        }}
                                        aria-expanded={activeItem === 'investment-13'}
                                    >
                                        Are the returns guaranteed?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-13' ? 'show' : ''}`}
                                    >
<div className='faq-body'>
                                        <p className='pb-2'>
                                            No,<span className='text-dark fw-bold'> returns are not guaranteed </span>, as all investments are subject to <span className='text-dark fw-bold'>market risks.</span> While<span className='text-dark fw-bold'> CoOwnSpace</span> may provide <span className='text-dark fw-bold'>estimates or projections,</span> these are purely indicative and should not be considered assured returns.
                                        </p>
                                        <p>We strongly advise investors to be cautious of any investment schemes that promise guaranteed returns, as real estate values and rental yields can fluctuate based on market conditions.</p>
                                    </div>
                                </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'investment-14' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('investment-14');
                                        }}
                                        aria-expanded={activeItem === 'investment-14'}
                                    >
                                        How do I exit my investment?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'investment-14' ? 'show' : ''}`}
                                    >
                                        <div className='d-flex flex-column gap-3 faq-body'>
                                            <p><strong className='text-dark'>Exiting Your Investment with CoOwnSpace</strong></p>
                                            <p className='d-flex flex-column gap-3'>We recognize that investment needs can change, so after your lock-in period, you have two options to sell your fractional ownership:</p>
                                            <p className='text-dark fw-bold '>1. Exit via Property Sale:</p>

                                            <ul style={{ listStyleType: 'disc', paddingLeft: '30px', }} >
                                                <li className='text-dark list-text py-1'>If a lucrative sale opportunity arises, <span className='text-dark fw-bold'>CoOwnSpace</span> will evaluate the offer and present it to investors.</li>
                                                <li className='text-dark list-text py-1'>If <span className='text-dark fw-bold'>% or more</span> of shareholders vote in favor, we will initiate the sale process.
                                                </li>
                                                <li className='text-dark list-text py-1'>After the property is sold, the <span className='text-dark fw-bold'> profits (post taxes and fees) </span> will be distributed to investors.</li>
                                            </ul>
                                            <p className='text-dark fw-bold'><strong>2. Exit via Share Resale:</strong></p>
                                            <ul style={{ listStyleType: 'disc', paddingLeft: '30px', }} >
                                                <li className='text-dark list-text py-1'>As a shareholder, you can <span className='text-dark fw-bold'>sell your stake </span> privately to someone you know.
                                                </li>
                                                <li className='text-dark list-text py-1'>Alternatively,<span className='text-dark fw-bold'> CoOwnSpace</span> can assist in finding a buyer through our investor network</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">Payments & Returns</h3>
                            <div className="box-faq" id="safety-faq">
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'safety-1' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('safety-1');
                                        }}
                                        aria-expanded={activeItem === 'safety-1'}
                                    >
                                        What is the minimum investment amount?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'safety-1' ? 'show' : ''}`}
                                    >
                                        <div className="faq-body">
                                            The minimum amount varies by property but is generally much lower than traditional real estate investments.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'safety-2' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('safety-2');
                                        }}
                                        aria-expanded={activeItem === 'safety-2'}
                                    >
                                        How do I receive rental income? <i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'safety-2' ? 'show' : ''}`}
                                    >
                                        <div className="faq-body">
                                            Rental income is distributed periodically based on ownership percentage, directly credited to your account.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'safety-3' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('safety-3');
                                        }}
                                        aria-expanded={activeItem === 'safety-3'}
                                    >
                                        Are there any additional fees?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'safety-3' ? 'show' : ''}`}
                                    >
                                        <div className="faq-body">
                                            There may be management fees for maintenance, property administration, and legal compliance, which are transparently outlined before investment.
                                        </div>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'safety-4' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('safety-4');
                                        }}
                                        aria-expanded={activeItem === 'safety-4'}
                                    >
                                        What is the expected return on investment (ROI)?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'safety-4' ? 'show' : ''}`}
                                    >
                                        <div className="faq-body">
                                            ROI depends on factors like rental yield, property appreciation, and market trends. Detailed financial projections are available for each property.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">Usage & Management</h3>
                            <div className="box-faq" id="usage-faq">
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'usage-1' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-1');
                                        }}
                                        aria-expanded={activeItem === 'usage-1'}
                                    >
                                        Can I use the property I invest in?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'usage-1' ? 'show' : ''}`}
                                    >
                                        <p className="faq-body">
                                            Yes, some properties (e.g., vacation homes) allow co-owners to use the space based on predefined terms.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'usage-2' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-2');
                                        }}
                                        aria-expanded={activeItem === 'usage-2'}
                                    >
                                        Who manages the property?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'usage-2' ? 'show' : ''}`}
                                    >
                                        <p className="faq-body">
                                            CoOwnSpace handles all property management, including maintenance, tenant screening, and legal compliance.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'usage-3' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-3');
                                        }}
                                        aria-expanded={activeItem === 'usage-3'}
                                    >
                                        What happens if a property is sold?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'usage-3' ? 'show' : ''}`}
                                    >
                                        <p className="faq-body">
                                            If the majority of owners vote to sell the property, the proceeds are distributed among shareholders based on their ownership percentage.
                                        </p>
                                    </div>
                                </div>

                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'usage-4' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-4');
                                        }}
                                        aria-expanded={activeItem === 'usage-4'}
                                    >
                                        How secure is my investment?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div
                                        className={`collapse ${activeItem === 'usage-4' ? 'show' : ''}`}
                                    >
                                        <p className="faq-body">
                                            We ensure legal transparency through proper documentation, secure transactions, and regulatory compliance to protect investor interests.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">
                                Referral Bonus & Rewards Program
                            </h3>
                            <div className="box-faq" id="support-faq">

                                {/* FAQ Item 1 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-1' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-1');
                                        }}
                                        aria-expanded={activeItem === 'support-1'}
                                    >
                                        Does CoOwnSpace have a Referral Bonus & Rewards program?
                                        <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-1' ? 'show' : ''}`}>
                                        <p className="faq-body ps-5">
                                            Yes, <span className='text-dark fw-bold'>CoOwnSpace</span> offers a <span className='text-dark fw-bold'>Referral Bonus & Rewards</span> program, allowing you to earn incentives for referring new investors. For details on rewards and eligibility, please contact our team.
                                        </p>
                                    </div>
                                </div>

                                {/* FAQ Item 2 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-2' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-2');
                                        }}
                                        aria-expanded={activeItem === 'support-2'}
                                    >
                                        How much is the referral bonus?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-2' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'><span className='text-dark fw-bold'>1 % of the investment sale value</span> (e.g., ₹5,00,000 investment → ₹5,000 bonus).</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* FAQ Item 3 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-3' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-3');
                                        }}
                                        aria-expanded={activeItem === 'support-3'}
                                    >
                                        How are rewards points calculated?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-3' ? 'show' : ''}`}>
                                        <div className='faq-body'>
                                            <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                                <li className='list-text py-1'><span className='text-dark fw-bold'>100% of the investment sale value in points</span> (₹1,00,000 investment = 1,00,000 points).</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>

                                {/* FAQ Item 4 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-4' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-4');
                                        }}
                                        aria-expanded={activeItem === 'support-4'}
                                    >
                                        What is the value of reward points?
                                        <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-4' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'><span className='text-dark fw-bold'>1% of total reward points</span> (e.g., 1,00,000 points = ₹1,000).</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* FAQ Item 5 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-5' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-5');
                                        }}
                                        aria-expanded={activeItem === 'support-5'}
                                    >
                                        When can I withdraw my rewards?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-5' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'>Once your rewards balance reaches <span className='text-dark fw-bold'>₹10,000</span> you can request a withdrawal.</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* FAQ Item 6 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-6' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-6');
                                        }}
                                        aria-expanded={activeItem === 'support-6'}
                                    >
                                        How do I refer to someone?
                                        <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-6' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'>Share your unique referral link from the platform.</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* FAQ Item 7 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-7' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-7');
                                        }}
                                        aria-expanded={activeItem === 'support-7'}
                                    >
                                        Is there a limit to referrals?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-7' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'>No, you can refer <span className='text-dark fw-bold'>unlimited</span> people and earn for each investment.</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* FAQ Item 8 */}
                                <div className="faq-item">
                                    <span
                                        className={`faq-header h6 ${activeItem === 'support-8' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('support-8');
                                        }}
                                        aria-expanded={activeItem === 'support-8'}
                                    >
                                        How will I receive my earnings?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'support-8' ? 'show' : ''}`}>
                                        <ul style={{ listStyleType: 'disc', paddingLeft: '30px' }}>
                                            <li className='list-text py-1'>Referral bonus and rewards are transferred to your <span className='text-dark fw-bold'>bank account</span> upon withdrawal request.</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">Taxation</h3>
                            <div className="box-faq" id="usage-faq-2">
                                {/* First FAQ Item */}
                                <div className="faq-item">
                                    <span
                                        href="#"
                                        className={`faq-header h6 ${activeItem === 'usage-5' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-5');
                                        }}
                                        aria-expanded={activeItem === 'usage-5'}
                                    >
                                        What is the tax implication on my returns?<i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'usage-5' ? 'show' : ''}`}>
                                        <div className="faq-body d-flex flex-column gap-4">
                                            {/* Property Appreciation (Capital Gains Tax) */}
                                            <div className='d-flex flex-column gap-3'>
                                                <p className='text-dark fw-bold'>1. Property Appreciation (Capital Gains Tax)</p>
                                                <span className='px-5'>When a property is sold, the profit earned is classified as capital gains:</span>
                                                <div style={{ paddingLeft: '30px' }}>
                                                    <ul style={{ listStyleType: 'disc' }}>
                                                        <li className='list-text py-1'>If the property is held for <span className='text-dark fw-bold'>more than 2 years</span>, the gains qualify as <span className='text-dark fw-bold'>long-term capital gains (LTCG)</span> and are taxed at 20% with indexation benefits, which help reduce taxable gains by adjusting for inflation.</li>
                                                        <li className='list-text py-1'>If the property is held for <span className='text-dark fw-bold'>2 years or less</span>, the gains are considered <span className='text-dark fw-bold'>short-term capital gains (STCG)</span> and are taxed as per the investor’s applicable <span className='text-dark fw-bold'>income tax slab rate.</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* Rental Yield Taxation */}
                                            <div className='d-flex flex-column gap-3'>
                                                <p className='text-dark fw-bold'>2. Rental Yield Taxation</p>
                                                <span className='px-5'>The taxation of rental income depends on the <span className='text-dark fw-bold'>Special Purpose Vehicle (SPV) structure</span> used for property ownership:</span>
                                                <div style={{ paddingLeft: '30px' }}>
                                                    <ul style={{ listStyleType: 'disc' }}>
                                                        <li className='list-text text-dark fw-bold py-1'>SPVs Structured as Private Limited Companies:
                                                            <div style={{ paddingLeft: '30px' }}>
                                                                <ul style={{ listStyleType: 'circle' }}>
                                                                    <li className='fw-medium py-1'>1. Rental income is categorized as <span className='fw-bold'>“Income from Other Sources”</span> for investors</li>
                                                                    <li className='fw-medium py-1'>2. It is taxed at the <span className='fw-bold'>individual investor’s applicable income tax slab rate.</span></li>
                                                                </ul>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Second FAQ Item */}
                                <div className="faq-item">
                                    <span
                                        href="#"
                                        className={`faq-header h6 ${activeItem === 'usage-6' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-6');
                                        }}
                                        aria-expanded={activeItem === 'usage-6'}
                                    >
                                        Is Tax Deducted at Source (TDS) applicable to my returns?
                                        <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'usage-6' ? 'show' : ''}`}>
                                        <div className="faq-body d-flex flex-column gap-4">
                                            <div>
                                                Yes, <span className='fe-bold text-dark'>TDS (Tax Deducted at Source)</span> is applicable based on the <span className='text-dark fw-bold'>structure of the SPV</span> and the <span className='text-dark fw-bold'>investor’s residency status</span>.
                                            </div>

                                            <div className='d-flex flex-column gap-3'>
                                                <p>1. SPV Structured as a Private Limited Company</p>
                                                <div style={{ paddingLeft: '30px' }}>
                                                    <ul style={{ listStyleType: 'disc' }}>
                                                        <li className='list-text py-1'><span className='text-dark fw-bold'>For Indian Residents:</span> TDS will be deducted at 10% on the rental income or dividends distributed.</li>
                                                        <li className='list-text py-1'><span className='text-dark fw-bold'>For Non-Resident Indians (NRIs):</span> TDS will be deducted at 20% or as per the applicable rate under the <span className='text-dark fw-bold'>Double Taxation Avoidance Agreement (DTAA)</span>, provided a <span className='text-dark fw-bold'>valid Tax Residency Certificate (TRC)</span> is furnished along with other necessary documentation.</li>
                                                        <li className='list-text py-1'>Additional surcharge and cess may apply as per the <span className='text-dark fw-bold'>Income Tax Act, 1961.</span></li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className='d-flex flex-column gap-3'>
                                                <p>2. SPV Structured as an LLP</p>
                                                <div style={{ paddingLeft: '30px' }}>
                                                    <ul style={{ listStyleType: 'disc' }}>
                                                        <li className='list-text py-1'>TDS is <span className='fw-bold'>not applicable</span> on income distributed to investors since LLPs are taxed at the entity level.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Third FAQ Item */}
                                <div className="faq-item">
                                    <span
                                        href="#"
                                        className={`faq-header h6 ${activeItem === 'usage-7' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-7');
                                        }}
                                        aria-expanded={activeItem === 'usage-7'}
                                    >
                                        How will the returns of an NRI be taxed?
                                        <i className="icon-CaretDown"></i>
                                    </span>
                                    <div className={`collapse ${activeItem === 'usage-7' ? 'show' : ''}`}>
                                        <div className="faq-body">
                                            <span>How Will the Returns of an NRI Be Taxed?</span>
                                            <div style={{ paddingLeft: '30px' }}>
                                                <ul style={{ listStyleType: 'disc' }}>
                                                    <li className='list-text py-1'><span className='text-dark fw-bold'>Taxable Income:</span> NRIs must pay tax on income earned or received in India, including rental income, capital gains, and interest credited to an NRO account, as per applicable slab rates.</li>
                                                    <li className='list-text py-1'><span className='text-dark fw-bold'>Basic Exemption:</span> ₹2.5 lakh per financial year (certain deductions may not apply).</li>
                                                    <li className='list-text py-1'><span className='text-dark fw-bold'>DTAA Benefits:</span> NRIs can claim relief under the Double Taxation Avoidance Agreement (DTAA) by providing a Tax Residency Certificate (TRC).</li>
                                                    <li className='list-text py-1'><span className='text-dark fw-bold'>TDS:</span> Rental income (20%), dividends (10%), and capital gains are subject to TDS at applicable rates, which can be adjusted when filing returns.</li>
                                                </ul>
                                            </div>
                                            Consult a tax advisor for the latest regulations.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tf-faq mb-49">
                            <h3 className="fw-8 title mb-24 text-center">Support & Assistance</h3>
                            <div className="box-faq" id="usage-faq-2">
                                <div className="faq-item">
                                    <a
                                        href="#"
                                        className={`faq-header h6 ${activeItem === 'usage-9' ? '' : 'collapsed'}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleToggle('usage-9');
                                        }}
                                        aria-expanded={activeItem === 'usage-9'}
                                    >
                                        What is the tax implication on my returns?<i className="icon-CaretDown"></i>
                                    </a>
                                    <div className={`collapse ${activeItem === 'usage-9' ? 'show' : ''}`}>
                                        <div className="faq-body d-flex flex-column gap-2">
                                            <div className="d-flex gap-2 align-items-center">
                                                <CgMail size={20} />
                                                <span>Email: support@coownspace.com</span>
                                            </div>

                                            <div className="d-flex gap-2 align-items-center">
                                                <IoCall size={20} />
                                                <span>Phone: +91 99411 11019</span>
                                            </div>

                                            {/* <div className="d-flex gap-2 align-items-center">
                                                <LuMessageSquareMore size={20} />
                                                <span>Live Chat: Available on our website</span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='col-xl-4 col-lg-5'>
                        <FormContactAgent />
                    </div>
                </div>
            </div>
        </section >
    );
};

export default Accordians;